module.exports = __webpack_public_path__ + "img/confetti_4c.0b1f2890.svg";